import classNames from 'classnames';
import React from 'react';
import Logo from '@/components/atoms/logo/logo';
import AlertBanner from '@/components/molecules/alert-banner/alert-banner';
import ProgressBar from '@/components/molecules/progress-bar/progress-bar';
import styles from './onboarding-curtain.module.scss';

export interface OnboardingCurtainProps {
  /** Current step content */
  children: React.ReactNode;
  /** The class name to apply */
  className?: string;
  /** Current step number */
  currentStep: number;
  /** Error message to display in the curtain */
  error?: string;
  /** Total step count */
  totalSteps: number;
}

const OnboardingCurtain = ({
  children,
  className,
  currentStep,
  error,
  totalSteps,
}: OnboardingCurtainProps) => {
  return (
    <aside className={classNames(styles.component, className)}>
      <div className={styles.header}>
        <Logo className={styles.logo} name="Login" />
      </div>

      {error && <AlertBanner text={error} variant="warning" />}

      <div className={styles.main}>{children}</div>

      <div className={styles.footer}>
        <ProgressBar currentStep={currentStep} totalSteps={totalSteps} />
      </div>
    </aside>
  );
};

OnboardingCurtain.displayName = 'OnboardingCurtain';

export default OnboardingCurtain;
